import { useQuery } from "@tanstack/react-query";
import { library } from "./query";
import { PostModel } from "common/models/BaseModel";
import { ILibraryGridFilter } from "./types";

export function GetLibrarys(model: PostModel<ILibraryGridFilter> | undefined) {
  return useQuery(library.list(model));
}

export function GetLibrary(Id: string | number) {
  return useQuery({
    ...library.getById(Id),
    enabled: Boolean(Id),
  });
}

export function GetLibraryValues() {
  return useQuery({
    ...library.getLibraryValues(),
    refetchOnMount: true,
  });
}

export function GetLibraryView(id: string | number | undefined, isOpen: boolean) {
  return useQuery({
    ...library.getViewById(id || ""),
    enabled: Boolean(id) && isOpen,
  });
}

export function GetGeneralSettings(Id: string | number) {
  return useQuery({
    ...library.getGeneralSettings(Id),
    enabled: Boolean(Id),
  });
}
export function GetGeneralSettingsByLibrary() {
  return useQuery({
    ...library.getGeneralSettingsByLibrary(),
  });
}

export function GetCirculationSettings(Id: string | number) {
  return useQuery({
    ...library.getCirculationSettings(Id),
    enabled: Boolean(Id),
  });
}

export function GetFineSettings(Id: string | number) {
  return useQuery({
    ...library.getFineSettings(Id),
    enabled: Boolean(Id),
  });
}

export function GetHolidaySettings(Id: string | number) {
  return useQuery({
    ...library.getHolidaySettings(Id),
    enabled: Boolean(Id),
  });
}

export function GetEmailSettings(Id: string | number) {
  return useQuery({
    ...library.getEmailSettings(Id),
    enabled: Boolean(Id),
  });
}
export function GetReminderSettings(Id: string | number) {
  return useQuery({
    ...library.getReminderSettings(Id),
    enabled: Boolean(Id),
  });
}

export function GetMemberCardSettings(Id: string | number) {
  return useQuery({
    ...library.getMemberCardSettings(Id),
    enabled: Boolean(Id),
  });
}

